/**
 * Amplify Configuration
 * 
 * Configuración de AWS Amplify para autenticación con Cognito
 */

import { Amplify } from 'aws-amplify'
import { configureAuth } from './auth'

export interface AmplifyConfig {
  Auth: {
    Cognito: {
      userPoolId: string
      userPoolClientId: string
      region: string
    }
  }
}

/**
 * Configura Amplify con las credenciales de Cognito
 */
export function configureAmplify(config: AmplifyConfig) {
  // Configurar Amplify
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: config.Auth.Cognito.userPoolId,
        userPoolClientId: config.Auth.Cognito.userPoolClientId,
        loginWith: {
          email: true,
        },
      },
    },
  }, {
    ssr: false,
  })

  // Validar configuración
  configureAuth({
    userPoolId: config.Auth.Cognito.userPoolId,
    userPoolClientId: config.Auth.Cognito.userPoolClientId,
    region: config.Auth.Cognito.region,
  })
}











